"use client";

import useWindowDimensions from "./useWindowDimensions";

interface WindowDimensions {
  width?: number;
  height?: number;
}

export const useScreen = () => {
  const dimension: WindowDimensions = useWindowDimensions();

  return {
    isMobile: dimension.width ? dimension.width < 768 : false,
  };
};
